import { render, staticRenderFns } from "./UserSquareSettings.vue?vue&type=template&id=27668a9e&scoped=true"
import script from "./UserSquareSettings.vue?vue&type=script&lang=js"
export * from "./UserSquareSettings.vue?vue&type=script&lang=js"
import style0 from "./UserSquareSettings.vue?vue&type=style&index=0&id=27668a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27668a9e",
  null
  
)

export default component.exports